import React from "react";

export const Page9Tamil = () => {
  return (
    <div className="page-tamil-container">
      <p>
        நேராக ஜோதிடரிடம் போனார். தூரத்தில் அவரைக் கண்டதுமே ஜோதிடர்
        அதிர்ச்சியடைந்தார். இதுவரை தன்னுடைய கணக்கு பொய்த்தது இல்லையே இவர்
        மட்டும் உயிர் பிழைத்து வந்திருக்கிறாரே என்று ஆச்சரியப்பட்டு அவரைப்
        பார்த்து இரவு என்ன நடந்தது என்று கேட்டார். அவரும் கோயிலில் தான்
        தங்கியதையும் விடிய விடிய தூங்காமல் அங்கோயிலுக்கு திருப்பணி செய்ய
        திட்டமிட்டுக் கொண்டிந்ததாகவும் தான் கோயிலை விட்டு வெளியே வந்தவுடன்
        கோயில் இடிந்து வீழ்ந்ததையும் விரிவாகச் சொன்னார். தான் உயிர் பிழைத்ததே
        ஆண்டவன் செயல் என்று சொன்னதைக் கேட்ட ஜோதிடர் அவர் காலில் விழுந்தார்.
        கோயில் திருப்பணிக்கு திட்டமிட்ட உனக்கே எமனிடமிருந்து விடுதலை என்றால்
        திருப்பணி செய்தால், செய்வதற்கு உதவி செய்தால் பெரிய பலன் கிடைக்குமே
        அதனால் என்னுடைய சொத்து முழுவதையும் உன்னிடம் ஒப்படைக்கிறேன் திருப்பணி
        செய் அதன் பலன் எனக்கும் கிடைக்கும் என்றார். இச்செய்தியை கேட்ட அவ்வூர்
        மக்களும் தங்களால் முடிந்தவரை திருப்பணிக்கு உதவினர். உத்தமனும்
        அக்கோயிலுக்கு சிறப்பாக திருப்பணி செய்தார்.
      </p>
      <p>
        கும்பாபிஷேகத்தையும் ஆகம விதிப்படி நடத்தி அதன்பலன் தனக்கும் அவ்வூர்
        மக்களுக்கும் கிடைக்கச் செய்து பெரும் பேறு பெற்றார்.
      </p>
      <p>
        இப்படிப்பட்ட உயர்ந்த பலன்தரும் கோயில் திருப்பணி கும்பாபிஷேகம் இவற்றுக்கு
        உதவுங்கள், நிதிமிகுந்தவர் பொற்குவைதாரீர், நிதி குறைந்தவர் சில
        காசுகளேனும் உதவுங்கள், அதுவும் இன்றேல் திருப்பணிக்கு உடல் உழைப்பைத்
        தாருங்கள் என்று அன்போடு வேண்டுகிறோம்
      </p>
      <p>
        புல்லினால் வருடம் கோடி புது மண்ணால் பத்துகோடி
        <br />
        செல்லுமா ஞாலம் தன்னில் செங்கல்லால் நூறுகோடி
        <br />
        அல்லியங்கோதை பாகன் ஆலயம் மடாலயங்கள் <br />
        கல்லினால் கட்டி வைத்தார் கயிலை விட்டு அகலார் அன்றே
      </p>
      <h1>கும்பாபிஷேக மென்னும் பெருஞ்சாந்தி விளக்கம்:</h1>
      <p>
        கும்பாபிஷேகத்திற்கு அங்கமாகச் செய்யப்படும் கிரியைகள் அறுபத்து
        நான்காகும். சில ஆகமங்கள் ஐம்பத்தைந்து என்று கூறும். அவற்றுள் அனுக்ஞை,
        கணபதி பூஜை, வாஸ்துசாந்தி, மிருத்சங்கிரணம், அங்குரார்ப்பணம்,
        ரக்ஷாபந்தனம், கும்பஸ்தாபனம், கலாகர்ஷனம், யாகசாலை பிம்பசுத்தி,
        ஸ்பார்சாகுதி, முதலியன இன்றியமையாதன. அனுக்ஞை ஆசாரியனைத் தேர்ந்து எடுத்து
        இறைவன் அனுமதி பெற்றுக் கும்பாபிஷேகம் செய்வித்ததற்கு நியமனம் செய்தலாகும்.
        கணபதி பூஜை காரியம் இடையூறின்றி நிகழ நிகழ்த்தும் வழிபாடு. வாஸ்து சாந்தி -
        பூமியைச் சுத்தம் செய்தல், மிருத்சங்கிரணம் - மண் எடுத்தல்,
        அங்குரார்ப்பணம் முளையிடுதல், ரக்ஷாபந்தனம் காப்புக் கட்டுதல், பிம்பசுத்தி
        செய்யப்படும் யாகப் பயன்களை மூர்த்திகளிடம் சேர்த்தல் இவ்வாறே ஒவ்வொரு
        கிரியையும் யாகசாலையில் நிகழும்.
      </p>
    </div>
  );
};
